// ─── Generische Paginations-Antwort ──────────────────────────────────────────

export interface PaginatedResponse<T> {
  items: T[];
  total: number;
  page: number;
  per_page: number;
}

// ─── API-Fehler-Typ & Hilfsfunktion ──────────────────────────────────────────

export interface ApiError {
  response?: {
    data?: { detail?: string };
    status?: number;
  };
  message?: string;
}

/**
 * Extrahiert eine lesbare Fehlermeldung aus einem unbekannten API-Fehler.
 * Unterstützt FastAPI-Fehlerobjekte (response.data.detail) sowie
 * generische Error-Objekte (message).
 */
export function getApiErrorMessage(
  err: unknown,
  fallback = 'Ein Fehler ist aufgetreten',
): string {
  const e = err as ApiError;
  return e?.response?.data?.detail ?? e?.message ?? fallback;
}
